import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <h1 className="font-heading text-primary text-6xl font-bold">404</h1>
      <p className="text-muted mt-4 text-lg">Page not found</p>
      <Link
        to="/composer"
        className="bg-accent text-accent-foreground hover:bg-accent/90 mt-8 rounded-md px-6 py-2 text-sm font-medium"
      >
        Go home
      </Link>
    </div>
  );
}
